import * as styles from '_download_/download-data-styles';
import format from '_shared_/plugins/format.js';
const $format = format.formatHelpers;

/**
 * Takes an array of integers representing widths (in pixels by default, if units not stated) and renders
 * a <colgroup> in HTML containing columns with each width
 * @param {} widths
 */
export const renderColumnWidths = widths => {
  let result = `<colgroup>`;
  widths && widths.forEach(width => {
    result += `<col style="width:${width}">`;
  });
  result += `</colgroup>`;
  return result;
};

/**
 * Renders a row gap (via <tr> tags) of varying size depending on number input
 * @param {*} number Number of row gaps to render, default is 1
 */
export const renderRowGaps = (number = 1) => {
  let result = ``;
  for (let i = 0; i < number; i++) {
    result += `<tr></tr>`;
  }
  return result;
};

/**
 * Renders a column gap (via <td> tags) of varying size depending on number input
 * @param {*} number Number of row gaps to render, default is 1
 */
export const renderColumnGaps = (number = 1) => {
  let result = ``;
  for (let i = 0; i < number; i++) {
    result += `<td></td>`;
  }
  return result;
};

/**
 * Renders a section/module header
 * @param {*} header Header text content
 * @returns
 */
export const renderSectionHeader = header => {
  return `
		<tr>
			<td style="${styles.textSection}${styles.textBold}${styles.textLeft}">${header}</td>
		</tr>
	`;
};

/**
 * Renders a customizeable colspan row
 * @param {*} content The text content of the header
 * @param {*} rowStyles String representation of CSS styling that should be in the row, default enpty
 * @param {*} numCols Number of columns that the cell should span, default is 1 row
 * @returns
 */
export const renderColSpanCell = (content, rowStyles = '', numCols = 1) => {
  return `
		<td style="${rowStyles}" colspan="${numCols}">${content}</td>
	`;
};

/**
 * Renders a section/module header with an "as of date"
 * @param {*} header Header content, styled black and bold
 * @param {*} asOfDateString String containing the "as of date", styled gray
 * @returns
 */
export const renderSectionHeaderAsOfDate = (header, asOfDateString) => {
  return `
		<tr>
			<td style="${styles.textSection}${styles.textBold}${styles.textLeft}">${header}</td>
			<td style="${styles.textSoft}${styles.textLeft}">${asOfDateString}</td>
		</tr>
	`;
};

/**
 * Renders a cell with a style of textMain and textLeft
 * @param {*} content Cell text content
 * @param {*} additionalStyles Additional styling, optional
 * @returns
 */
export const renderMainLeftCell = (content, additionalStyles) => {
  const cellStyles = additionalStyles ?
    `${styles.textMain}${styles.textLeft}${additionalStyles}` :
    `${styles.textMain}${styles.textLeft}`;
  return `<td style="${cellStyles}">${content}</td>`;
};

/**
 * Renders a cell with a style of textMain and textRight
 * @param {*} content Cell text content
 * @param {*} additionalStyles Additional styling, optional
 * @returns
 */
export const renderMainRightCell = (content, additionalStyles) => {
  const cellStyles = additionalStyles ?
    `${styles.textMain}${styles.textRight}${additionalStyles}` :
    `${styles.textMain}${styles.textRight}`;
  return `<td style="${cellStyles}">${content}</td>`;
};

/**
 * Renders a cell with a style of textSoft and textRight
 * @param {*} content Cell text content
 * @param {*} additionalStyles Additional styling, optional
 * @returns
 */
export const renderSoftRightCell = (content, additionalStyles) => {
  const cellStyles = additionalStyles ?
    `${styles.textSoft}${styles.textRight}${additionalStyles}` :
    `${styles.textSoft}${styles.textRight}`;
  return `<td style="${cellStyles}">${content}</td>`;
};

/**
 * Renders a cell with a style of textSoft and textLeft
 * @param {*} content Cell text content
 * @param {*} additionalStyles Additional styling, optional
 * @returns
 */
export const renderSoftLeftCell = (content, additionalStyles) => {
  const cellStyles = additionalStyles ?
    `${styles.textSoft}${styles.textLeft}${additionalStyles}` :
    `${styles.textSoft}${styles.textLeft}`;
  return `<td style="${cellStyles}">${content}</td>`;
};

/**
 * Renders a row containing label and a value in percent form
 * @param {*} content Cell text content
 * @param {*} additionalStyles Additional styling, optional
 * @returns
 */
export const renderPercentRow = (label, value, percentDecimals = 1) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(label);
  rowString += percentDecimals === 1 ?
    renderMainRightCell($format.rawPercent(value, 1), styles.percentSingleDecimal) :
    renderMainRightCell($format.rawPercent(value, percentDecimals));
  rowString += `</tr>`;
  return rowString;
};

/**
 * Renders the Fund Detail sheet title banner
 * @param {*} title String containing Title text
 * @returns
 */
export const renderFundDetailTitle = title => {
  return `
		<tr>
			<td colspan="6" style="${styles.textTitle}${styles.textBold}">${title}</td>
		</tr>
	`;
};
